export class EntityFactory {
  static getEntityInstance<Entity>(type: { new(): Entity; }): Entity {
    return new type();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/factory/entity-factory.ts